import { Button, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const { Text } = Typography;
interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddNote: (note: string) => void;
}

type FormStateType = {
  note: string;
};

const initFormState: FormStateType = {
  note: ''
};

export default function AddConfirmNote({ open, setOpen, handleAddNote }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState(initFormState);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleAddNote(formState.note);
        setOpen(false);
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={
        <Text>
          Lý do không xác nhận <Text type='danger'>*</Text>
        </Text>
      }
      centered
      maskClosable={false}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form
        form={form}
        labelCol={{ span: 7 }}
        fields={[
          {
            name: 'note',
            value: formState.note
          }
        ]}
      >
        <Form.Item label={false} name='note' rules={[{ required: true, message: '' }]}>
          <TextArea
            onChange={(e) => setFormState({ note: e.target.value })}
            rows={4}
            placeholder='Nhập lý do không xác nhận'
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
